import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_BEGIN,
  SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_SUCCESS,
  SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_FAILURE,
  SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_DISMISS_ERROR,
} from './constants';

export function loadCollectionInSchedule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionInScheduleError() {
  return {
    type: SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_BEGIN:
      return {
        ...state,
        loadCollectionInSchedulePending: true,
        loadCollectionInScheduleError: null,
      };

    case SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_SUCCESS:
      return {
        ...state,
        loadCollectionInSchedulePending: false,
        loadCollectionInScheduleError: null,
        collections: action.data,
      };

    case SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_FAILURE:
      return {
        ...state,
        loadCollectionInSchedulePending: false,
        loadCollectionInScheduleError: action.data.error,
      };

    case SCHEDULE_LOAD_COLLECTION_IN_SCHEDULE_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionInScheduleError: null,
      };

    default:
      return state;
  }
}
